import React from "react";
import { SingleColumnLayout } from "../../_layouts/SingleColumnLayout";
import { PageHeader } from "../../../designSystem/PageHeader";
import { P } from "../../../designSystem/typography/Body";
import { clientAccessHelper } from "../../../utils/clientAccessHelper";
import { ProtectedPageContext } from "../../_contexts/ProtectedPageContext";
import { UserPageWrapper } from "../../_pageWrappers/UserPageWrapper";


export default function ContactSupportPage(): JSX.Element 
{
    return (
        <UserPageWrapper breadCrumbs={[{ text: 'Har du brug for hjælp?', url: '' }]}>
            <ContactSupportPageContent />
        </UserPageWrapper>
    );
}

function ContactSupportPageContent(): JSX.Element 
{
    const activeUser = React.useContext(ProtectedPageContext).user;
    const hasAccess = clientAccessHelper.hasAllPermissions(activeUser, ['ViewActivityOverview']);

    if (!hasAccess)
        return <P>Hov! Du har ikke rettigheder til at tilgå denne side.</P>;

    return (
        <>
            <PageHeader narrow headerText="Har du brug for hjælp?" headerStyle='primary-black' />
        <SingleColumnLayout narrow>
            <>
                <P>
                Hvis du har spørgsmål eller brug for assistance, er vi her for at hjælpe. <br/>
                Send os en e-mail på <a href="mailto:support@amorg.dk">support@amorg.dk</a>, og vi vender tilbage så hurtigt som muligt.
                </P>

                <P>
                Amorg er et produkt, der gør det nemt at
                </P>
                <ul>
                    <li>Oprette spørgeskemaer til afholdelse af APV</li>
                    <li>Se statestikker for besvarede spørgsmål udfra valgte parametre</li>
                    <li>Tilknytte handleplaner når spørgeskemaer er besvaret</li>
                    <li>Følge med i alle punkter i handleplan</li>
                    {/* <li>Planlægge og udføre sikkerhedsrunderinger</li> */}
                    <li>Arrangere AMOmøder</li>
                    <li>Oprette agendaer til AMOmøder</li>
                    <li>Skrive referat til AMOmøder</li>
                    {/* <li>Benytte vores whistleblowerordning</li> */}
                </ul>
                <P>
                    Vi er dedikerede til at sikre, at du får den bedst mulige oplevelse med vores løsning.<br /><br />
                    Hvis der er yderligere spørgsmål, er du velkommen til at kontakte os.<br />
                    Tak fordi du valgte os!
                </P>
            </>
        </SingleColumnLayout>
        </>
    );
}